import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/global.css'  // Global styles imported here


createApp(App).use(router).mount('#app')
